import React from 'react';
import {Row, Col, Icon, Menu, Button, Popover, Dropdown} from 'antd';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {setLanguage, setAccount, setChain, setBalance} from "../actions/app";
import {enquireScreen} from 'enquire-js';
import {t} from "../utils/i18n";
import {login} from "../common/login";
import {Truncate} from "../common/text";
import Emitter from "../eventBus";


let isMobile;

enquireScreen((b) => {
    isMobile = b;
});

class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            menuVisible: false,
            menuMode: 'horizontal',
            currentPath: 'home',
            isLogin: false,
        };
        this.loginInterval = null;
    }

    componentDidMount() {
        enquireScreen((b) => {
            this.setState({menuMode: b ? 'horizontal' : 'horizontal'});
        });
        window.addEventListener('hashchange', (e) => {
            this.updatePath();
        });
        this.updatePath();
        setTimeout(() => {
            login(localStorage.getItem('wallet'), this.props);
        }, 500)

        window.addEventListener('message', (data) => {
            if (data.data.message) {
                if (data.data.message.action == 'setAccount' || data.data.message.action == 'accountsChanged') {
                    login(localStorage.getItem('wallet'), this.props);
                }
            }
        })

        this.loginInterval = setInterval(() => {
            login(localStorage.getItem('wallet'), this.props);
        }, 30000)

    }

    componentWillUnmount() {
        clearInterval(this.loginInterval);
    }

    scrollToAnchor = (anchorName) => {
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView({behavior: "smooth"});
            }
        }
    }

    updatePath = () => {
        let path = window.location.hash;
        let hash = path.substring(2, path.length);
        this.setState({currentPath: hash === '' ? 'home' : hash});
    }

    handleShowMenu = () => {
        this.setState({menuVisible: true})
    }
    handleCloseMenu = () => {
        this.setState({menuVisible: false})
    }
    handleMenuClick = e => {
        this.setState({
            currentPath: e.key === 'rules' ? 'home' : e.key,
        });
    };

    onMenuVisibleChange = menuVisible => {
        this.setState({menuVisible});
    };

    setLanguage = (lang) => {
        this.props.setLanguage(lang);
    }

    onLanguageClick = ({key}) => {
        this.props.setLanguage(key);
        localStorage.setItem('_lang', key);
    };

    onTitleClick = e => {
        e.domEvent.stopPropagation();
    };

    connect = () => {
        Emitter.emit('showMessageModal', {source: 'login'});
    }

    quit = () => {
        localStorage.removeItem('wallet');
        this.props.setAccount(null);
    }

    filePageCheck = (event) => {
        let {currentAccount} = this.props;
        if (!currentAccount) {
            event.preventDefault();
            event.stopPropagation();
            Emitter.emit('showMessageModal', {source: 'login'});
        }
    }

    render() {

        const {activeLanguage, currentAccount} = this.props;
        const {menuMode, menuVisible, currentPath} = this.state;
        const language = (
            <Menu onClick={this.onLanguageClick}>
                <Menu.Item key="en">English</Menu.Item>
                <Menu.Item key="zh">中文</Menu.Item>
            </Menu>
        );

        const menu = (
            <Menu style={{background: "transparent"}} mode={menuMode} id="nav" key="nav" onClick={this.handleMenuClick}
                  selectedKeys={[currentPath]}>

                {(currentPath === 'home' && !isMobile) &&
                <Menu.Item key='justin'>
                    <Link to="/justin">
                        <span> Justin@BTFS </span>
                    </Link>
                </Menu.Item>}

                {(currentPath === 'home' && !isMobile) &&
                <Menu.Item key='rules' onClick={(e) => this.scrollToAnchor('rules')}>
                    <a>
                        {t('user_guide')}
                    </a>
                </Menu.Item>}

                <Menu.Item key="files">
                    <Link to="/files" onClick={(event) => {
                        this.filePageCheck(event)
                    }}>
                        {t('my_files')}
                    </Link>
                </Menu.Item>

                {/* !isMobile && <Dropdown overlay={language} className="ml-8">
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                        {activeLanguage === 'en' ? 'English' : '中文'}
                    </a>
                </Dropdown> */}

            </Menu>
        );

        const quit = (<Menu>
            <Menu.Item>
                <a href={'https://tronscan.io/#/address/' + currentAccount} target='_blank'>
                    <i className="fas fa-frog ml-4 mr-4"></i> {t('go_to')} TronScan
                </a>
            </Menu.Item>
            <Menu.Item>
                <a onClick={this.quit}>
                    <i className="fas fa-sign-out-alt ml-4 mr-4"></i> {t('logout')}
                </a>
            </Menu.Item>
        </Menu>)

        return (
            <div id="header" className="_container header z-100">
                {menuMode === 'inline' ? (
                    <Popover
                        overlayClassName="popover-menu"
                        placement="bottomRight"
                        content={<div onClick={this.handleCloseMenu}>{menu}</div>}
                        trigger="click"
                        visible={menuVisible}
                        arrowPointAtCenter
                        onVisibleChange={this.onMenuVisibleChange}
                    >
                        <Icon className="nav-phone-icon" type="menu"
                              onClick={this.handleShowMenu}
                        />
                    </Popover>
                ) : null}
                <Row>
                    <Col xxl={4} lg={8} md={8} sm={4} xs={4}>
                        <div>
                            <div id="logo" style={{cursor: 'pointer'}}>
                                <Link to="/">
                                    <img src={require("../images/logo.png").default} alt="logo"/>
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={20} lg={16} md={16} sm={20} xs={20}>
                        <div className="header-meta flex items-center flex-row-reverse">
                            <div id="connect">
                                <a id="button" rel="noopener noreferrer">
                                    {!currentAccount && <Button style={{display: 'inline'}} onClick={() => {
                                        this.connect()
                                    }}>
                                        {t('connect_wallet')}
                                    </Button>
                                    }
                                    {
                                        currentAccount &&
                                        <Dropdown overlay={quit} placement="bottomCenter" overlayClassName="address">
                                            <Button>
                                                <Truncate>{currentAccount}</Truncate>
                                            </Button>
                                        </Dropdown>
                                    }
                                </a>
                                {!isMobile && <Dropdown overlay={language} placement='bottomCenter' className="ml-4-rem"
                                                        overlayClassName="lang">
                                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                        <span>  {activeLanguage === 'en' ? 'EN' : '中文'}  </span>
                                    </a>
                                </Dropdown>}
                            </div>
                            {menuMode === 'horizontal' ? <div id="menu">{menu}</div> : null}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeLanguage: state.app.activeLanguage,
        currentAccount: state.app.currentAccount
    };
}

const mapDispatchToProps = {
    setLanguage,
    setAccount,
    setChain,
    setBalance
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header))